var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.showModal}},[_c('i',{staticClass:"fa",class:_vm.icon,attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }